module.exports = __webpack_public_path__ + "img/chargingpoint-in-progress.c131cfeb.png";